var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.platform.marketplace",
  title: "EGT Platform — Marketplace",
  description: "One checkout for everything you sell — products, variants, carts, receipts; the customer stays yours.",
  supportServer: true,
  fields: { reserveUrl: { title: "Reserve URL", type: "uri", description: "Reservation entry point.", required: false } }
});
var P = require("../helpers/egt.platform.sections.js");

exports.render = async function render(options) {
  var reserve = (options && options.reserveUrl) || "/reserve";
  return P.capabilityPage({
    id: "marketplace", reserve: reserve,
    media: { video: "/vis/database.mp4", poster: "/vis/database.jpg", width: "1920", height: "1920", parallax: 0.06 },
    eyebrow: "The Universe Platform · Marketplace",
    title: [ "One checkout for ", { n: "br" }, "everything you ", { n: "span", c: "egt__gold", i: "sell." } ],
    lead: "Products, variants, subscriptions, and digital goods move through a single flow — and the customer relationship stays yours, not the platform's.",
    /* SEO wave 2C-5/2C-7 (2026-10-09): answer-first definition, who it's for,
     * and straight answers drawn only from objections the site already answers. */
    answer: "Marketplace is the store and checkout inside the Universe Platform by EGT — one checkout for products, variants, subscriptions and digital goods, for businesses that want to keep the customer relationship instead of renting it back from a marketplace. It's part of the public beta.",
    forTitle: "For businesses that sell — and want to keep the customer.",
    forWho: [
      { title: "Shops selling physical and digital", copy: "Physical items, downloads and subscriptions check out together in one cart, with no stitched-together tools." },
      { title: "Owners who want their buyers back", copy: "The customer's contact and history stay with you, on the same record as your site and your email." },
      { title: "Merchants who want plain terms", copy: "You are the merchant of record, terms are shown before payment, and processing fees are a separate, honest line." }
    ],
    faq: [
      [ "Who is the merchant of record?",
        "You are. Terms are shown before payment, and Stripe's processing fees are a separate, honest line through your own account. We never promise we handle every tax everywhere — we tell you the truth." ],
      [ "Does anything charge on its own?",
        "No. Intrepid, the platform's AI partner, proposes and never acts: it never charges, sends or publishes without your say-so." ],
      [ "Can I export my data and leave?",
        "Yes. Your customers, orders, content and email list are yours, held as a grant, not a copy. Export them and walk anytime — an integrated core shouldn't mean a locked door." ]
    ],
    spineEyebrow: "What it does",
    spineTitle: "From browse to receipt, one flow.",
    spineLead: "Selling isn't a separate app you reconcile against your site — it's the same records, the same customers, the same system.",
    points: [
      { title: "The customer is yours", copy: "You keep the relationship and the contact — not a marketplace that rents your own buyers back to you." },
      { title: "Everything in one cart", copy: "Physical, digital, and subscription items check out together through one universal flow — no stitched-together tools." },
      { title: "Honest by design", copy: "You are the merchant of record; terms are shown before payment. We never promise we handle every tax everywhere — we tell you the truth." }
    ],
    honesty: "Your store. Your customers. Your call.",
    honestyLead: "The merchant is you — which means the relationship, the data, and the decisions belong to you, not to us.",
    honestyMedia: { img: "/imgs/egt-platform-canvas.jpg", alt: "", parallax: true }
  });
};
